<template>
  <div class="partner-list swiper-container-free-mode">
    <ul class="swiper-wrapper">
      <li v-for="item in brandList" :key="item.id" class="swiper-slide partner-item">
        <span class="icon">
          <img :src="item.attributes.logo.data.attributes.url" :alt="item.attributes.alt" />
        </span>
      </li>
    </ul>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
export default {
  name: 'BrandSwiper',
  props: {
    brandList: [Array]
  },
  data() {
    return {
      brandSwiper: null
    }
  },
  mounted() {
    this.initSwiper()
  },
  methods: {
    initSwiper() {
      setTimeout(() => {
        this.brandSwiper = new Swiper('.partner-list', {
          slidesPerView: 'auto',
          spaceBetween: 20,
          loop: true,
          autoplay: {
            delay: 1,
            disableOnInteraction: false
          },
          speed: 1000,
          // pagination: {
          //   el: '.swiper-pagination',
          //   clickable: true
          // },
          observer: true,
          observeParents: true
        })
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
//partner list
.partner-list {
  overflow: hidden;
  position: relative;
  margin-bottom: 20px;
  padding-bottom: 40px;
  .swiper-wrapper {
    transition-timing-function: linear;
    .partner-item {
      width: 100px;
      .icon {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $white2;
        overflow: hidden;
        border-radius: 50%;
      }

      img {
        display: block;
        width: 54px;
        height: auto;
      }
    }
  }
}
</style>
